import { timeout } from '../../../../../utils/common/common-utils';
import { get, post } from '../../../../account/hardware/api-helpers';
import { BASE_IPV4_ADDRESS } from './constants';

type DeviceWifiNetwork = {
  signal: number; // Value between -100 and 0, where -100 is the weakest signal
  ssid: string;
  security: string;
  type: string;
  bars: number;
  bssid: string;
  chan: number;
};

type WifiConnectHistoryEntry = {
  ssid: string;
  timestamp: number;
  status: string;
};

export type DeviceWifiStatus = {
  connect_history: WifiConnectHistoryEntry[];
  dsn: string;
  device_service: string;
  log_service: string;
  mac: string;
  mtime: number;
  host_symname: string;
  connected_ssid: string;
  ant: number;
  rssi: number;
  bars: number;
};

type WifiStatusResponse = {
  wifi_status: DeviceWifiStatus;
};

type WifiScanResponse = {
  wifi_scan: WifiScan;
};

type WifiScan = {
  mtime: number;
  results: DeviceWifiNetwork[];
};

/**
 * Fetches the current Wi-Fi status of the device.
 */
export async function fetchWifiStatus(): Promise<DeviceWifiStatus> {
  const deviceWifiStatus: WifiStatusResponse = await get(`${BASE_IPV4_ADDRESS}/wifi_status.json`);
  return deviceWifiStatus.wifi_status;
}

/**
 * Triggers a scan for nearby Wi-Fi networks (from the POV of the wi-fi device we are connected to).
 */
export async function scanAndFetchWifiNetworks(): Promise<DeviceWifiNetwork[]> {
  await post(`${BASE_IPV4_ADDRESS}/wifi_scan.json`, {});
  await timeout(5_000); // wait for scan to complete, helps ensure results are available before fetching results
  const wifiScanResults: WifiScanResponse = await get(`${BASE_IPV4_ADDRESS}/wifi_scan_results.json`);
  return wifiScanResults.wifi_scan.results;
}

/**
 * Sends a request to the device to connect to a specific Wi-Fi network.
 *
 * @param ssid The SSID of the Wi-Fi network.
 * @param password The password for the Wi-Fi network.
 */

/* istanbul ignore next -- @preserve */
export async function connectToWifiNetwork(ssid: string, password: string): Promise<void> {
  const params = `?ssid=${ssid}&key=${password}`;
  return await post(`${BASE_IPV4_ADDRESS}/wifi_connect.json${params}`, {});
}
